import {useContext, useEffect, useState} from "react";
import {CartContextProps, CartContextType, CartItemBase, CartListItem} from "./ShoppingCartContextTypes";
import {UserContext} from "../../../hooks/userContext";
import {useQueryCart} from "../../../queries/product/hooks/useQueryCart";

export function ShoppingCartContextProvider<TItemType extends CartItemBase>({
  children,
  context
}: CartContextProps<TItemType>) {
  const { id }: any = useContext(UserContext);
  const { data, loading } = useQueryCart({
    variables: {
      where: { userId: { equals: +id } },
      orderBy: { createdAt: 'asc' }
    }
  });

  const [products, setProducts] = useState < CartListItem < TItemType > [] > ([]);
  const getProductById = (id: string): CartListItem<TItemType> | undefined => {
    return products.find(p => p.item.id === id)
  }
  const addProductToCart = (product: CartListItem<TItemType>): void => {
    const existingProduct = getProductById(product.item.id)
    let newState: CartListItem<TItemType>[] = []
    if (existingProduct) {
      newState = products.map((p) => {
        if (p.item.id === existingProduct.item.id) {
          return {
            id: p.id,
            item: p.item,
            // quantity: p.quantity + product.quantity
          }
        }
        return p
      })
      setProducts(newState)
    }
    setProducts([...products, product])
  }
  const removeProductFromCart = (product: TItemType) => {
    const newProducts = products.filter(p => p.item.id !== product.id)
    setProducts(newProducts)
  }

  useEffect(() => {
    if (data?.findManyCart) {
      const cartData: any = [];
      data?.findManyCart.forEach((item: any) => {
        cartData.push({
          id: item.id,
          quantity: item.quantity,
          item: item.Product,
          user: item.User
        })
      });
      setProducts(cartData);
    }
  }, [data]);

  const contextValue: CartContextType<TItemType> = {
    cart: products,
    addProductToCart,
    removeProductFromCart,
    loading,
  }

  return <context.Provider value={contextValue}>{children}</context.Provider>
}